import { useState } from "react";
const STORAGE_KEY = "sidebarExpanded";

const readStored = (): boolean => {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return stored === null ? true : stored === "true";
  } catch {
    return true;
  }
};

const useSidebarExpanded = () => {
  const [expanded, setExpandedState] = useState<boolean>(readStored);

  const setExpanded = (value: boolean | ((prev: boolean) => boolean)) => {
    setExpandedState((prev) => {
      const next = typeof value === "function" ? value(prev) : value;
      try {
        window.localStorage.setItem(STORAGE_KEY, String(next));
      } catch {
        // Storage unavailable (private mode, disabled cookies, etc.) — the
        // toggle still works for the current page, it just won't persist.
      }
      return next;
    });
  };

  return [expanded, setExpanded] as const;
};

export default useSidebarExpanded;
